<div class="wrapper flex flex-col">
  <div class="heading mb-[24px] flex flex-row justify-between items-center">
    <div class="counter text-type-2">{{ item ? 'Update material test' : 'Create material test' }}</div>
    <mat-icon (click)="onCancel()">close</mat-icon>
  </div>
  <div class="flex flex-row w-full mb-[24px] gap-[10px]">
    <app-text-input
      (checkForErrors)="checkForErrors($event)"
      [error]="errorMessages['name']"
      [parentFormGroup]="form"
      class="w-full"
      controlName="name"
      label="Name"
    />
  </div>
  <div class="actions mt-auto">
    <app-primary-button (handleClick)="onSave()" [isDisabled]="!form.valid"> Save </app-primary-button>
  </div>
</div>
